<template>
  <div class="plan-game-template">
    <div class="plan-head">
      <p class="title">
        Planning n°{{ currentPlanning.label }}
      </p>
      <div class="game-menu">
        <p>Ce planning est...</p>
        <div>
          <button class="answer-button good" @click="answerPlanning(true)">Bon</button>
          <button class="answer-button not-good" @click="answerPlanning(false)">Pas bon</button>
        </div>
      </div>
      <div class="tabs">
        <div class="tab-menu">
          <div class="tab-item" :class="{ current: tabName === 'checklist' }" @click="changeTab('checklist')">
            CHECKLIST
          </div>
          <div class="tab-item" :class="{ current: tabName === 'help' }" @click="changeTab('help')">
            Comment lire le planning
          </div>
        </div>
        <div class="tabs-wrapper">
          <div class="tab" v-show="tabName === 'checklist'">
            <checklist :enable="true"></checklist>
          </div>
          <div class="tab" v-show="tabName === 'help'">
            <div class="help-planning">
              <div>
                <div class="help">
                  <div class="tag-wrapper">
                    <img src="../assets/tags/tag-cpg.png">
                  </div>
                  <div class="text">
                    <strong>Absence pour Congé Payé</strong>
                  </div>
                </div>
                <div class="help">
                  <div class="tag-wrapper">
                    <img src="../assets/tags/tag-rtt.png">
                  </div>
                  <div class="text">
                    <strong>Absence pour RTT</strong>
                  </div>
                </div>
                <div class="help">
                  <div class="tag-wrapper">
                    <img src="../assets/tags/tag-pat.png">
                  </div>
                  <div class="text">
                    <strong>Congé Paternité et d’accueil.</strong> Généralement, les absences de couleur rose correspondent aux absences maladie (Arrêt Maladie, Accident du travail…)
                  </div>
                </div>
                <div class="help">
                  <div class="tag-wrapper">
                    <img src="../assets/tags/tag-qte-travail.png">
                  </div>
                  <div class="text">
                    <strong>Quantité de travail planifié</strong>, indiquée sur les dimanches.
                    <p class="example">En fonction de votre société vous pourriez aussi voir le nombre d’heures excédentaires effectuées.</p>
                  </div>
                </div>
              </div>
              <div>
                <div class="help">
                  <div class="tag-wrapper">
                    <img src="../assets/tags/tag-ref.png">
                  </div>
                  <div class="text">
                    <strong>Jour de repos pour les salariés au forfait</strong>, à prendre en cas de journées supplémentaires travaillées
                    <p class="example">Exemple : le samedi lorsque vous faites 6 jours par semaine</p>
                  </div>
                </div>
                <div class="help">
                  <div class="tag-wrapper">
                    <img src="../assets/tags/tag-rec.png">
                  </div>
                  <div class="text">
                    <strong>Récupération en contrepartie d’heures excédentaire</strong>, elle est soit posée en « jour » soit en « heure ».
                  </div>
                </div>
                <div class="help">
                  <div class="tag-wrapper">
                    <img src="../assets/tags/tag-memo.png">
                  </div>
                  <div class="text">
                    <strong>Mémo :</strong> la ligne INFORMATION permet de lire ou créer un commentaire.
                    <p class="example">Utile pour : retard, problème de justificatif, départ anticipé, changement d’horaire, nature de l’évènement familial...</p>
                  </div>
                </div>
                <div class="help">
                  <div class="tag-wrapper">
                    <img src="../assets/tags/tag-etoile.png">
                  </div>
                  <div class="text">
                    <strong>Étoile rouge : la plage horaire prévue a été modifiée</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="plan-image">
      <img :src="require(`../assets/plannings/${currentPlanning.image}`)">
    </div>
  </div>
</template>

<script>
import Checklist from './Checklist'

export default {
  name: 'PlanGameTemplate',
  components: {
    Checklist
  },
  data () {
    return {
      tabName: 'checklist'
    }
  },
  computed: {
    currentPlanning () {
      return this.$store.getters.currentPlanning
    },
    plannings () {
      return this.$store.state.plannings
    }
  },
  methods: {
    changeTab (tab) {
      this.tabName = tab
    },
    answerPlanning (value) {
      this.$store.commit('setPlanningAnswer', value)
      this.$store.dispatch('navigate', 'planningGame')
    }
  }
}
</script>

<style lang="scss">
.plan-game-template {
  .plan-head {
    padding: 12px 25px;
    background-color: $primary-color;
    position: relative;
    .title {
      font-weight: 700;
      font-size: 1.4rem;
      color: #fff;
      position: absolute;
      top: 25px;
      left: 50%;
      transform: translateX(-50%);
    }
    .game-menu {
      position: absolute;
      display: flex;
      align-items: center;
      right: 25px;
      top: 12px;
      > div {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      p {
        color: #fff;
        font-weight: 700;
        margin-right: 20px;
        font-size: 0.9rem;
      }
      .answer-button + .answer-button {
        margin-left: 8px;
      }
      .answer-button {
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
        padding-left: 20px;
        height: 50px;
        width: 140px;
        font-size: 0.9rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        color: $secondary-color;
        border-radius: $radius-sm;
        font-weight: 700;
        cursor: pointer;
        border: none;
        background-repeat: no-repeat;
        background-position: left 15px center;
        &.good {
          background-image: url('../assets/good.svg');
        }
        &.not-good {
          background-image: url('../assets/not-good.svg');
        }
        &:hover {
          box-shadow: none;
        }
      }
    }
    .tabs {
      margin-top: 20px;
      .tab-menu {
        display: flex;
        align-items: center;
        .tab-item {
          padding: 15px 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: $radius $radius 0 0;
          background-color: rgba(255, 255, 255, 0.8);
          font-weight: 700;
          color: $secondary-color;
          cursor: pointer;
          position: relative;
          bottom: -1px;
          &.current {
            cursor: default;
            background-color: #fff;
            color: $primary-text-color;
            font-family: $secondary-font;
          }
        }
      }
      .tabs-wrapper {
        border-radius: 0 $radius $radius $radius;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        border: 1px solid $background-color;
        padding: 20px 25px;
        background-color: #fff;
      }
    }
  }
  .plan-image {
    max-width: 100%;
    img {
      width: 100%;
    }
  }
  .help-planning {
    display: flex;
    > div {
      width: 50%;
      margin-top: -15px;
    }
    .help {
      margin-top: 15px;
      display: flex;
      .tag-wrapper {
        min-width: 76px;
        width: 76px;
        text-align: center;
        img {
          height: auto;
          width: auto
        }
      }
      .text {
        margin-left: 15px;
        text-align: left;
        font-family: $secondary-font;
        font-size: 0.9rem;
        .example {
          color: $light-text-color;
        }
      }
    }
  }
}

@media (max-width: 1070px) {
  .plan-game-template .plan-head .game-menu {
    flex-direction: column;
    top: 6px;
    p {
      margin-bottom: 5px;
    }
  }
  .plan-game-template .plan-head .title {
    padding-left: 110px;
  }
}
</style>
